import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 24px;
	box-sizing: border-box;

	@media (max-width: 768px) {
		padding: 16px;
	}
`;

export const card = styled.div`
	background: ${color.interface.white};
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
	border: 1px solid ${color.interface.lightGray4};
	padding: 32px;
	display: flex;
	flex-direction: column;
	gap: 28px;
	max-width: 760px;
	width: 100%;

	@media (max-width: 768px) {
		padding: 20px;
	}
`;

export const header = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;

	h2 {
		font-size: 20px;
		font-weight: 600;
		color: ${color.interface.darkgray};
		margin: 0;
	}

	p {
		font-size: 14px;
		color: ${color.interface.lightGray};
		margin: 0;
	}
`;

export const divider = styled.hr`
	border: none;
	border-top: 1px solid ${color.interface.lightGray4};
	margin: 0;
	width: 100%;
`;

export const form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
`;

export const fieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	width: 100%;
`;

export const fieldHint = styled.span`
	font-size: 12px;
	color: ${color.interface.darkgray2};
	margin-top: -2px;
`;

export const actions = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
	margin-top: 8px;

	@media (max-width: 768px) {
		justify-content: stretch;

		button {
			width: 100%;
		}
	}
`;

export const saveButton = styled.button<{ $isLoading?: boolean }>`
	background-color: ${color.interface.lightBlue2};
	color: ${color.interface.white};
	border: none;
	border-radius: 4px;
	padding: 10px 28px;
	font-size: 14px;
	font-weight: 600;
	cursor: ${(props) => (props.$isLoading ? 'not-allowed' : 'pointer')};
	opacity: ${(props) => (props.$isLoading ? 0.7 : 1)};
	transition: all 0.2s ease-in-out;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	min-width: 160px;
	height: 42px;

	&:hover {
		filter: brightness(0.95);
		box-shadow: 0 2px 6px rgba(113, 182, 249, 0.4);
	}

	&:active {
		filter: brightness(0.9);
	}
`;

export const loadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 240px;
	width: 100%;
`;
